import { render, staticRenderFns } from "./getDirectAPK.vue?vue&type=template&id=09a92db2&"
import script from "./getDirectAPK.vue?vue&type=script&lang=js&"
export * from "./getDirectAPK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports